module.exports = __webpack_public_path__ + "static/maxima-telecom-screen-1-4a9174b031a6c028c88b82fc016199c1.png";